import { BiChevronRight } from "react-icons/bi";
import { CarePlusMedication } from "../../ChooseTreatmentCarePlus/types";
import { buildImageUrl, dosageRange, minDosagePrice, usageCadence } from "../helpers";
import { FrequencyIcon } from "./ModalOptionRow";
import PriceValue from "./PriceValue";

const ExploreOptionsCard = ({ medication, onSelect, t }: { medication: CarePlusMedication; onSelect: () => void; t: (key: string, fallback: string) => string }) => {
  const imageUrl = buildImageUrl(medication.image);
  return (
    <button
      id={`wl3_treatment_explore_${medication.catalog_id}`}
      type="button"
      onClick={onSelect}
      className="flex cursor-pointer w-full items-start gap-[14px] rounded-[12px] border border-[#f5f5f4] bg-white px-[16px] py-[13px] text-left drop-shadow-[0px_12px_6px_rgba(0,0,0,0.05)]"
    >
      <div className="flex h-[91px] w-[95px] shrink-0 items-center justify-center overflow-hidden rounded-[6px] bg-[#f5f6f7]">
        {imageUrl && <img src={imageUrl} alt={medication.title} className="h-full w-full object-contain" />}
      </div>
      <div className="flex min-w-0 flex-1 flex-col justify-between self-stretch">
        <p className="text-[18px] font-medium leading-[1.2] text-[#08080a]">{medication.title}</p>
        <div className="flex flex-col gap-[4px]">
          <p className="text-[10px] text-[#99a3b2]">{dosageRange(medication)}</p>
          <div className="flex items-center gap-1">
            <FrequencyIcon medication={medication} />
            <p className="text-[10px] text-[#99a3b2]">{usageCadence(medication, t)}</p>
          </div>
          <p className="text-[12px] text-[#7a7a7a]">
            <PriceValue value={minDosagePrice(medication)} prefix={`${t("from", "from")} `} suffix={` ${t("per_mo", "/mo")}`} className="font-medium text-[#616975]" />
          </p>
        </div>
      </div>
      <div className="flex size-8 shrink-0 items-center justify-center self-end rounded-full bg-[#f5f6f7]">
        <BiChevronRight size={16} className="text-[#08080a]" />
      </div>
    </button>
  );
};

export default ExploreOptionsCard;
